import type { TFunction } from 'i18next';
import { getDateLocale } from 'ccs-ui-components';

/** Mirrors ccs-ui-components TopNavigation default items (CIP AI Designer is opened from the dashboard, not the header). */
export interface AppHeaderUrlProps {
  CP: { path: string | undefined; permission: boolean };
  JD: { path: string | undefined; permission: boolean };
  OD: { path: string | undefined; permission: boolean };
  DP: { path: string | undefined; permission: boolean };
  ANE: { path: string | undefined; permission: boolean };
  UM: { path: string | undefined; permission: boolean };
}

export function buildAppTopNavItems(
  translate: TFunction,
  URL: AppHeaderUrlProps
): Array<Record<string, unknown>> {
  const lang = getDateLocale();
  return [
    {
      title: translate('common_top_navigation.txt_control_plane'),
      path: `${URL.CP.path}?language=${lang}`,
      baseURL: `${URL.CP.path}`,
      subItems: [
        {
          title: translate('common_top_navigation.txt_events'),
          path: `${URL.CP.path}/events?language=${lang}`
        },
        {
          title: translate('common_top_navigation.txt_services'),
          path: `${URL.CP.path}/services?language=${lang}`
        },
        {
          title: String(translate('common_top_navigation.txt_exceptions')),
          path: `${URL.CP.path}/exceptions?language=${lang}`
        },
        {
          title: String(translate('common_top_navigation.txt_registries')),
          path: `${URL.CP.path}/registries?language=${lang}`
        },
        {
          title: String(translate('common_top_navigation.txt_maintenance')),
          path: `${URL.CP.path}/configuration?language=${lang}`
        }
      ],
      permission: URL.CP.permission
    },
    {
      title: String(translate('common_top_navigation.txt_journey_designer')),
      path: `${URL.JD.path}/view-journeys?language=${lang}`,
      baseURL: `${URL.JD.path}`,
      permission: URL.JD.permission
    },
    {
      title: String(translate('common_top_navigation.txt_data_pipeline')),
      path: `${URL.DP.path}?language=${lang}`,
      baseURL: `${URL.DP.path}`,
      isNewWindow: true,
      permission: URL.DP.permission
    },
    {
      title: String(
        translate('common_top_navigation.txt_obesevability_dashboard')
      ),
      path: `${URL.OD.path}?language=${lang}`,
      baseURL: `${URL.OD.path}`,
      subItems: [
        {
          title: String(translate('common_top_navigation.txt_journey')),
          path: `${URL.OD.path}/journeys?language=${lang}`
        },
        {
          title: String(translate('common_top_navigation.txt_query_search')),
          path: `${URL.OD.path}/query-search?language=${lang}`
        },
        {
          title: String(translate('common_top_navigation.txt_recovery')),
          path: `${URL.OD.path}/reprocessFailures/failureList?language=${lang}`
        },
        {
          title: String(
            translate('common_top_navigation.txt_export_reporting')
          ),
          path: `${URL.OD.path}/reporting/export?language=${lang}`
        },
        {
          title: String(
            translate('common_top_navigation.txt_import_reporting')
          ),
          path: `${URL.OD.path}/reporting/import?language=${lang}`
        }
      ],
      permission: URL.OD.permission
    },
    {
      title: String(translate('common_top_navigation.txt_ane')),
      path: `${URL.ANE.path}?language=${lang}`,
      baseURL: `${URL.ANE.path}`,
      permission: URL.ANE.permission
    },
    {
      title: String(translate('common_top_navigation.txt_administration')),
      path: `${URL.UM.path}?language=${lang}`,
      baseURL: `${URL.UM.path}`,
      permission: URL.UM.permission
    }
  ];
}
